﻿const cleanupMap = new Map();

export function formInitInputSelect(id, assemblyName) {
    const dropdownElement = document.getElementById(id);
    if (!dropdownElement || dropdownElement.dataset.hasInit) return;
    const input = dropdownElement.querySelector('input');
    const control = dropdownElement.querySelector('.form-control');
    const dropdownMenu = dropdownElement.querySelector('ul');
    input?.addEventListener('keydown', (event) => {
        // Tab, Enter, ArrowUp, ArrowDown
        if (['Tab', 'Enter', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
            event.preventDefault();
        }
    });
    control.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') {
            event.preventDefault();
        }
    });
    const outsideClickListener = (event) => {
        if (!document.body.contains(dropdownElement)) {
            document.removeEventListener('click', outsideClickListener);
            return;
        }
        const isMenuOpen = dropdownMenu && dropdownMenu.classList.contains('show');
        if (isMenuOpen && !dropdownElement.contains(event.target)) {
            dropdownMenu.classList.remove('show');
            try {
                if (assemblyName != null) {
                    console.log("Calling .NET TriggerAction for id:", id);
                    // Gọi hàm [JSInvokable] TriggerAction
                    // assemblyName là tên Project chứa class FormStandardInterop (VD: "MyProject.Client" hoặc "HT.Common")
                    DotNet.invokeMethodAsync(assemblyName, 'TriggerAction', id)
                        .catch(err => console.error("Error calling TriggerAction:", err));
                } else if (nativeExports?.HT?.Common?.CommonClientInterop) {
                    console.log("Calling native TriggerAction for id:", id);
                    // Gọi trực tiếp hàm [JSExport] TriggerAction
                    nativeExports.HT.Common.CommonClientInterop.TriggerAction(id);
                } else {
                    console.warn("No valid .NET interop found for TriggerAction.");
                }
            } catch (error) {
                // Nếu .NET object chết thì hủy luôn listener
                document.removeEventListener('click', outsideClickListener);
            }
        }
    };
    // Đăng ký sự kiện click toàn cục
    document.addEventListener('click', outsideClickListener);
    dropdownElement.dataset.hasInit = "true";
    cleanupMap.set(id, () => {
        document.removeEventListener('click', outsideClickListener);
    });
}
export function formSetInputSelect(id, isShow, isFocus) {
    const dropdownElement = document.getElementById(id);
    if (!dropdownElement) return;
    const menu = dropdownElement.querySelector('ul');
    const input = dropdownElement.querySelector('input');
    const control = dropdownElement.querySelector('.form-control');
    if (!menu) return;
    if (isShow) {
        menu.classList.add('show');
        if (isFocus && input) 
            safeFocus(input);
    } else {
        menu.classList.remove('show');
        if (isFocus && control) 
            safeFocus(control);
    }
}
export async function formInitEditForm(id) {
    const element = document.getElementById(id);
    if (!element || element.dataset.listening) return;
    const btnSubmit = element.querySelector("button[type='submit']");
    if (!btnSubmit) return;
    const wrapper = btnSubmit.parentElement;
    if (!wrapper.classList.contains("d-none")) return;
    // console.log("Adding event listeners for form:", id);
    const handleShow = function (e) {
        wrapper.classList.remove("d-none");
        element.removeEventListener("input", handleShow);
        element.removeEventListener("change", handleShow);
        delete element.dataset.listening;
    };
    element.addEventListener("input", handleShow);
    element.addEventListener("change", handleShow);
    element.dataset.listening = "true";
}  
export function formDispose(id) {
    const cleanup = cleanupMap.get(id);
    if (cleanup) {
        cleanup(); // Chạy hàm removeEventListener
        cleanupMap.delete(id); // Xóa khỏi bộ nhớ
    }
}